/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { DigiticketsEvent } from './DigiticketsEvent';
import {
    DigiticketsEventFromJSON,
    DigiticketsEventFromJSONTyped,
    DigiticketsEventToJSON,
    DigiticketsEventToJSONTyped,
} from './DigiticketsEvent';
import type { CacheMeta } from './CacheMeta';
import {
    CacheMetaFromJSON,
    CacheMetaFromJSONTyped,
    CacheMetaToJSON,
    CacheMetaToJSONTyped,
} from './CacheMeta';

/**
 * 
 * @export
 * @interface ListDigiticketsEventsResponse
 */
export interface ListDigiticketsEventsResponse {
    /**
     * 
     * @type {CacheMeta}
     * @memberof ListDigiticketsEventsResponse
     */
    cache: CacheMeta;
    /**
     * 
     * @type {Array<DigiticketsEvent>}
     * @memberof ListDigiticketsEventsResponse
     */
    data: Array<DigiticketsEvent>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDigiticketsEventsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDigiticketsEventsResponse interface.
 */
export function instanceOfListDigiticketsEventsResponse(value: object): value is ListDigiticketsEventsResponse {
    if (!('cache' in value) || value['cache'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDigiticketsEventsResponseFromJSON(json: any): ListDigiticketsEventsResponse {
    return ListDigiticketsEventsResponseFromJSONTyped(json, false);
}

export function ListDigiticketsEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDigiticketsEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cache': CacheMetaFromJSON(json['cache']),
        'data': ((json['data'] as Array<any>).map(DigiticketsEventFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDigiticketsEventsResponseToJSON(json: any): ListDigiticketsEventsResponse {
      return ListDigiticketsEventsResponseToJSONTyped(json, false);
  }

  export function ListDigiticketsEventsResponseToJSONTyped(value?: ListDigiticketsEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cache': CacheMetaToJSON(value['cache']),
        'data': ((value['data'] as Array<any>).map(DigiticketsEventToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

